import { createReducer, on } from "@ngrx/store";
import { AuthState } from "./auth.state";
import { HttpErrorResponse } from "@angular/common/http";
import { isLoginFailedResponse } from "../interfaces/login-failed-response";
import { TokenError, TokenIsExpiredError } from "../interfaces/token-error";
import { authServiceActions, liveLessonAuthActions } from "./auth-service.actions";
import { ensureError } from "@pcp/core/util";

export const authFeatureKey = 'auth';

export const initialState: AuthState = {
    token: undefined,
    refreshToken: undefined,
    tokenIsValid: false,
    tokenExpiresAt: undefined,
    isAuthenticated: false,
    isLoggingIn: false,
    loginFailedReason: undefined,
    claims: undefined,
};

export const reducer = createReducer(
    initialState,


    on(
        authServiceActions.userLoginRequested,
        liveLessonAuthActions.userLoginRequested,
        (state, action): AuthState => ({
            ...state,
            isLoggingIn: true,
        }),
    ),
    on(
        authServiceActions.userLoginSuccess,
        authServiceActions.tokenRestoreSuccess,
        authServiceActions.tokenRefreshSuccess,
        liveLessonAuthActions.userLoginSuccess,
        liveLessonAuthActions.tokenRestoreSuccess,
        (state, action): AuthState => ({
            ...state,
            isLoggingIn: false,
            isAuthenticated: true,
            loginFailedReason: undefined,
            token: action.tokenData.token,
            refreshToken: action.tokenData.refreshToken,
            // TODO: mapping/transforming claims should be done in the decoder service
            claims: action.tokenData.claims,
            tokenExpiresAt: action.tokenData.expiresAt,
            tokenIsValid: true,
        }),
    ),
    on(
        authServiceActions.userLoginFailed,
        liveLessonAuthActions.userLoginFailed,
        (state, { error }): AuthState => {
            let reason: string | undefined = ensureError(error).message;

            if (error instanceof TokenError) {
                console.error(error);
                reason = error.message;
            }

            if (error instanceof TokenIsExpiredError) {
                console.error(error);
            } else if (error instanceof HttpErrorResponse) {
                console.error(error);
            }

            if (isLoginFailedResponse(error)) {
                console.error(error);
                reason = error.error.errorMessage;
            }

            return ({
                ...state,
                isLoggingIn: false,
                isAuthenticated: false,
                loginFailedReason: reason,
            });
        },
    ),
    on(
        authServiceActions.tokenRestoreFailed,
        liveLessonAuthActions.tokenRestoreFailed,
        (state): AuthState => ({
            ...state,
            ...initialState,
            loginFailedReason: 'Token restore failed',
        })
    ),
    on(
        authServiceActions.userHasBeenLoggedOut,
        (): AuthState => ({
            ...initialState,
        })
    ),

    // Token refresh state
    on(
        authServiceActions.tokenRefreshFailed,
        (state): AuthState => ({
            ...state,
            ...initialState,
            isAuthenticated: false
        })
    ),
);


